import type { Option } from "@tento-lona/sheets";

/**
 * Storage backend for preferences. Structurally matches the Web Storage API
 * subset so `localStorage` can be passed directly. Tests can provide an
 * in-memory implementation.
 */
export interface PreferencesStorage {
  getItem(key: string): Option<string>;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

/**
 * A `PreferencesStorage` held in memory, for scripts and tests that persist
 * nothing.
 */
export class MemoryStorage implements PreferencesStorage {
  #data = new Map<string, string>();

  getItem(key: string): Option<string> {
    return this.#data.get(key) ?? null;
  }

  setItem(key: string, value: string): void {
    this.#data.set(key, value);
  }

  removeItem(key: string): void {
    this.#data.delete(key);
  }
}
